import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import MarketingTracker from "@/components/MarketingTracker";
import MarketingLinkTracker from "@/components/MarketingLinkTracker";
import Home from "@/pages/Home";
import Challenge from "@/pages/Challenge";
import Chat from "@/pages/Chat";
import Pricing from "@/pages/Pricing";
import Support from "@/pages/Support";
import GameModule from "@/pages/GameModule";
import Auth from "@/pages/Auth";
import Tournaments from "@/pages/Tournaments";
import TournamentDetail from "@/pages/TournamentDetail";
import Leaderboard from "@/pages/Leaderboard";
import Calendar from "@/pages/Calendar";
import Rules from "@/pages/Rules";
import News from "@/pages/News";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import BalatroHub from "@/pages/BalatroHub";
import GuidePage from "@/pages/GuidePage";
import Gta6Hub from "@/pages/Gta6Hub";
import Gta6GuidePage from "@/pages/Gta6GuidePage";
import StaticPage from "@/pages/StaticPage";
import PasswordReset from "@/pages/PasswordReset";
import { ShareBuild, BuildCard } from "@/pages/RunBuilds";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MarketingTracker />
        <MarketingLinkTracker />
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/challenge" element={<Challenge />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/tournaments" element={<Tournaments />} />
              <Route path="/tournaments/:id" element={<TournamentDetail />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/news" element={<News />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/players/:id" element={<Profile />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/balatro" element={<BalatroHub />} />
              <Route path="/balatro/:slug" element={<GuidePage />} />
              <Route path="/gta-6" element={<Gta6Hub />} />
              <Route path="/gta-6/:slug" element={<Gta6GuidePage />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/support" element={<Support />} />
              <Route path="/login" element={<Auth />} />
              <Route path="/forgot-password" element={<PasswordReset />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/game/:id" element={<GameModule />} />
              <Route path="/builds/new" element={<ShareBuild />} />
              <Route path="/build/:id" element={<BuildCard />} />
              <Route path="/:slug" element={<StaticPage />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
